import { CustomModule } from './tenant.setting';

// Human-readable metadata for each custom module, used to render legible names/descriptions on the
// Custom Modules settings page. The enum value stays the canonical id stored in the allowlist; this
// map only affects display. See ./custom.modules.md.
export interface CustomModuleMetaEntry {
    label: string;
    description: string;
}


// Typed as Record<CustomModule, ...> so the compiler requires an entry for every module — adding a
// new CustomModule without a label/description will fail to build.
export const CustomModuleMeta: Record<CustomModule, CustomModuleMetaEntry> = {
    [CustomModule.BifEvents]: { label: 'BIF Events', description: 'BGIS BIF Events board and manual event capture.' },
    [CustomModule.SupplementaryWorks]: { label: 'Supplementary Works', description: 'Adds the Submit Supplementary Request action to a stage, sending pending items to the connected integration.' },
    [CustomModule.AddItemsWithoutAuthority]: { label: 'Add Items Without Authority', description: 'Temporary. Adds the Add Items Without Authority action to a stage, adding pending items straight to the HomesVIC job without an authority request. BGIS tenants only.' },
    [CustomModule.RequestItemDeletion]: { label: 'Request Deletion of Items', description: 'Adds the Request Deletion of Items action to a stage, asking HomesVIC to delete selected authorised lines and cancelling them once HomesVIC accept. BGIS tenants only.' },
};


// Safe lookup for a module id coming from the persisted allowlist (a plain string), which may not be
// a known CustomModule value — hence the `| undefined` return.
export function customModuleMeta(id: string): CustomModuleMetaEntry | undefined {

    return (CustomModuleMeta as Record<string, CustomModuleMetaEntry>)[id];
}


// Resolve a legible label for a module id. Falls back to spacing out the PascalCase id so an unmapped
// value still displays cleanly.
export function customModuleLabel(id: string): string {

    return customModuleMeta(id)?.label ?? id.replace(/([a-z])([A-Z])/g, '$1 $2');
}
